export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 pt-14 pb-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-open-line text-background-50 text-lg"></i>
              </span>
              <span className="font-heading font-bold text-lg text-background-50">
                九妖漫画网
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              九妖漫画网为漫画爱好者提供免费漫画全集大全，涵盖国漫推荐、日漫精选、韩漫热门等海量免费下拉式漫画资源，支持免费追更与最新章节提醒，满足您随时随地免费在线阅读的需求。
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-bold text-sm text-background-100 mb-4">
              快速导航
            </h4>
            <div className="flex flex-col gap-2">
              <a href="#hero" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer">首页</a>
              <a href="#topics" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer">热门话题</a>
              <a href="#ranking" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer">漫画排行</a>
              <a href="#updates" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer">更新动态</a>
              <a href="#faq" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer">常见问题</a>
            </div>
          </div>

          {/* Categories */}
          <div>
            <h4 className="font-heading font-bold text-sm text-background-100 mb-4">
              漫画分类
            </h4>
            <div className="flex flex-col gap-2">
              <span className="text-sm text-background-400 whitespace-nowrap">国漫推荐</span>
              <span className="text-sm text-background-400 whitespace-nowrap">日漫精选</span>
              <span className="text-sm text-background-400 whitespace-nowrap">韩漫热门</span>
              <span className="text-sm text-background-400 whitespace-nowrap">热血漫画</span>
              <span className="text-sm text-background-400 whitespace-nowrap">恋爱漫画</span>
            </div>
          </div>

          {/* Partners */}
          <div>
            <h4 className="font-heading font-bold text-sm text-background-100 mb-4">
              合作伙伴
            </h4>
            <p className="text-sm text-background-500 leading-relaxed">
              期待与更多优质内容平台、漫画创作者及行业伙伴建立合作，共同为漫画爱好者打造更丰富的阅读生态。
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-background-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 九妖漫画网 - 免费漫画全集大全免费下拉式追更平台
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <span className="cursor-pointer hover:text-background-300 transition-colors whitespace-nowrap">用户协议</span>
            <span className="cursor-pointer hover:text-background-300 transition-colors whitespace-nowrap">隐私政策</span>
            <span className="cursor-pointer hover:text-background-300 transition-colors whitespace-nowrap">版权声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}